module.exports = __webpack_public_path__ + "static/media/img_delivery.536f7ae7.png";